import { Component, OnInit, OnDestroy, Input, ViewChild, AfterViewChecked } from '@angular/core';
import { UtilService, DialogService } from '../../../../shared/index';
import { EventRead } from '../../../shared/event-read.model';
import { RegistrationUpsert } from 'src/app/events-v4/shared/registration/crud/registration-upsert.model';
import { RegistrationItem } from 'src/app/events-v4/shared/registration/registration-item.model';
import { CreditCardPaymentInfo } from '../../../../revenue/shared/credit-card/credit-card-payment-info.model';
import { CreditCardContactInfo } from '../../../../revenue/shared/credit-card/credit-card-contact-info.model';
import { IValidationComponent } from '../../../../shared/widgets/component/ivalidation.component';
import { ValidationResult } from '../../../../shared/widgets/validators/validation-result.model';
import { TranslationService } from '../../../../shared/translation/translation.service';
import { EventPaymentMethod } from '../../../../events/shared/payment-methods/event-payment-method.model';
import { CreditCardService } from '../../../../revenue/shared/credit-card/credit-card.service';
import { CreditCardInputComponent } from '../../../../revenue/credit-card-input/credit-card-input.component';
import { EventPromoCode } from '../../../shared/promo-codes/event-promo-code.model';
import { PromoCodeDiscountType } from '../../../shared/promo-codes/promo-code-discount-type';
import { GatewayPaymentProfile, isSavedCardSelected } from '../../../../revenue/shared/credit-card/card-on-file/gateway-payment-profile.model';
import { GatewayCustomerProfile } from '../../../../revenue/shared/credit-card/card-on-file/gateway-customer-profile.model';
import { RegistrationRevenue } from 'src/app/events-v4/shared/registration/registration-revenue.model';
import { CreditCardGatewayService } from '../../../../revenue/shared/credit-card-gateway/credit-card-gateway.service';

import { RegistrationProfileBenefit } from 'src/app/events-v4/shared/registration/registration-profile-benefit.model';
import { ProfileBenefit } from '../../../../benefits/shared/profile-benefit.model';
import { EventBenefit } from '../../../../benefits/shared/event-benefit.model';
import { BenefitService } from '../../../../benefits/shared/benefit.service';
import { EventPriceBenefit } from '../../../../benefits/shared/event-price-benefit.model';
import { ConfigService } from '../../../../config/shared/config.service';
import { ConfigSetting } from '../../../../config/shared/config-setting.model';
import { EventV4PaymentMethodService } from 'src/app/events-v4/shared/payment-methods/event-v4-payment-method.service';
import { EventV4PromoCodesService } from 'src/app/events-v4/shared/promo-codes/event-v4-promo-codes.service';
import { EventV4RegistrationService } from 'src/app/events-v4/shared/registration/event-v4-registration.service';
import { RegistrationPaymentGatewaysDto } from 'src/app/events-v4/shared/registration/registration-payment-gateways.dto';
import { EventRegistrationActionTrackerService } from 'src/app/events-v4/shared/event-registration-action-tracker.service';
import { EventRegistrationEditActionDto } from 'src/app/events-v4/shared/dto/event-registration-edit-action.dto';
import { EventRegistationActionTypeEnum } from 'src/app/events-v4/shared/dto/event-registation-action-type.enum';
import { EventItemTotal } from 'src/app/events/registration/shared/registration-event-item-total.model';
import { forEach } from 'lodash-es';
import { InvoiceLineItem } from 'src/app/revenue/shared/invoice/invoice-lineitem.model';
import { InvoiceLineItemDto } from 'src/app/invoices/dto/invoice-line-item.dto';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GatewayResolutionService } from '../../../../revenue/shared/gateway-resolution/gateway-resolution.service';
import { TokenizeGatewayDto } from '../../../../revenue/shared/gateway-resolution/dto/tokenize-gateway.dto';

@Component({
  selector: 'wl-event-v4-registration-wizard-payment-info',
  styleUrls: ['event-v4-registration-wizard-payment-info.component.css'],
  templateUrl: 'event-v4-registration-wizard-payment-info.component.html',
  providers: [
    EventV4PaymentMethodService,
    CreditCardService,
    EventV4PromoCodesService,
    EventV4RegistrationService,
    BenefitService,
    CreditCardGatewayService,
  ],
    standalone: false
})
export class EventV4RegistrationWizardPaymentInfoComponent implements OnInit, OnDestroy, IValidationComponent, AfterViewChecked {
  @ViewChild('creditCardInputComponent', { static: false }) creditCardInputComponent: CreditCardInputComponent;

  public _utilService: UtilService;
  public _translationService: TranslationService;
  public _paymentMethodService: EventV4PaymentMethodService;
  public _eventPromoCodesService: EventV4PromoCodesService;
  public _registrationService: EventV4RegistrationService;
  public _creditCardService: CreditCardService;
  public _benefitService: BenefitService;
  public _configService: ConfigService;
  public _creditCardGatewayService: CreditCardGatewayService;

  public promoCodeDiscountType: any = PromoCodeDiscountType;

  public registrationId: number;
  public registration: RegistrationUpsert = new RegistrationUpsert();
  public event: EventRead = new EventRead();
  public initialLoadComplete: boolean = false;

  // The gateway the Preczn card widget tokenizes against, from revenue-item resolution. This is
  // NOT the same question as _primaryGatewayId (events-v4), which is payment-type-keyed and
  // answers whose stored card-on-file profiles to list; the two can legitimately disagree and are
  // deliberately kept apart.
  public resolvedGateway: TokenizeGatewayDto | null = null;
  private _onDestroy$ = new Subject<void>();

  public paymentMethods: Array<EventPaymentMethod>;

  public eventPromoCodes: Array<EventPromoCode>;
  public selectedPromoCode: number;
  public originalAmountPaid: number;

  public hasCardOnFile: boolean;
  public hasCreditCardOnFileEnabled: boolean;
  public gatewayCustomerProfile: GatewayCustomerProfile = new GatewayCustomerProfile();
  public selectedGatewayPaymentProfile: GatewayPaymentProfile = new GatewayPaymentProfile();
  public gatewayPaymentProfiles: Array<GatewayPaymentProfile>;

  public selectedCcPaymentProfileId: string = '';
  public readonly isSavedCardSelected = isSavedCardSelected;
  public hasPaymentOptionFees: boolean = false;

  private _primaryGatewayId: number = 0;
  private loadedRevenue: RegistrationRevenue;

  public availableEventBenefits: Array<EventBenefit>;
  public availableProfileBenefits: Array<ProfileBenefit>;
  public availableBenefitsToUse: Array<EventBenefit>;

  public selectedProfileBenefit: ProfileBenefit;
  public selectedEventBenefit: EventBenefit;
  public selectedRegistrationBenefit: RegistrationProfileBenefit;

  public hasBenefitsThatCanBeUsed: boolean;
  public showPromoCodeNotStarted: boolean = false;
  public showPromoCodeExpired: boolean = false;
  public showPromoCodeMaxedOut: boolean = false;

  public lineItemAccountingPackageIds: Array<number> = [];
  public paymentAccountingPackageIds: Array<number> = [];
  public hasRefundableCcPayment: boolean = false;

  public constructor(
    utilService: UtilService,
    translationService: TranslationService,
    paymentMethodService: EventV4PaymentMethodService,
    eventPromoCodesService: EventV4PromoCodesService,
    registrationService: EventV4RegistrationService,
    creditCardService: CreditCardService,
    benefitService: BenefitService,
    configService: ConfigService,
    creditCardGatewayService: CreditCardGatewayService,
    private actionTracker: EventRegistrationActionTrackerService,
    private _gatewayResolutionService: GatewayResolutionService
  ) {
    this._utilService = utilService;
    this._translationService = translationService;
    this._paymentMethodService = paymentMethodService;

    this._eventPromoCodesService = eventPromoCodesService;
    this._registrationService = registrationService;
    this._creditCardService = creditCardService;
    this._configService = configService;
    this._creditCardGatewayService = creditCardGatewayService;

    this._benefitService = benefitService;

    this.paymentMethods = new Array<EventPaymentMethod>();
    this.eventPromoCodes = new Array<EventPromoCode>();
    this.selectedPromoCode = 0;
    this.registrationId = 0;
    this.originalAmountPaid = 0;

    this.hasCardOnFile = false;
    this.hasCreditCardOnFileEnabled = false;
    this.gatewayPaymentProfiles = new Array<GatewayPaymentProfile>();

    this.availableEventBenefits = new Array<EventBenefit>();
    this.availableProfileBenefits = new Array<ProfileBenefit>();
    this.availableBenefitsToUse = new Array<EventBenefit>();

    this.selectedProfileBenefit = new ProfileBenefit();
    this.selectedEventBenefit = new EventBenefit();
    this.selectedRegistrationBenefit = new RegistrationProfileBenefit();
    this.hasBenefitsThatCanBeUsed = false;
  }

  ngOnInit() {
    this._gatewayResolutionService
      .observeTokenizeGatewayForCard()
      .pipe(takeUntil(this._onDestroy$))
      .subscribe((gateway) => {
        this.resolvedGateway = gateway;
      });
  }

  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  /**
   * Re-resolves the tokenizing gateway from the currently selected revenue items.
   *
   * The host calls this from registrationItemsChanged(), not only at mount: this payment step is
   * instantiated eagerly and merely hidden between wizard steps, so the component instance
   * survives every item change. Resolving once at mount would leave the gateway stale the moment
   * the registrant changed what they were buying.
   */
  public refreshResolvedGateway = (): Promise<void> => {
    const itemNums = (this.registration?.Items ?? []).filter((item) => item.Quantity > 0).map((item) => item.ItemNum);
    return this._gatewayResolutionService.resolveForRevenueItems(itemNums).then(() => {});
  };

  ngAfterViewChecked() {
    //see if even though an item may not have changed but now they select a custom field
    //that has a cost see if the total has changed
    if (this.registration.IsEdit) {
      //we changed from OriginalInvoiceTotalAmount to OriginalItemTotalAmount because a manually invoice could so the same amount if a registration has no profiel info then staff manually changes the invoice price to a member price then a staff goes to edit the reg to then apply a member profileid to it.  The
      if (
        this._utilService.round(this.registration.Registration.OriginalItemTotalAmount, 2) !=
        this._utilService.round(this.registration.Registration.TotalAmount, 2)
      ) {
        this.registration.EditTotalAmountChanged = true;
      } else {
        this.registration.EditTotalAmountChanged = false;
      }
    }
  }

  public loadData(): Promise<any> {
    const getEventPaymentMethodPromise = this._paymentMethodService
      .getEventPaymentMethods(this.event.EventId)
      .then((data: Array<EventPaymentMethod>) => {
        this.paymentMethods = data;
        if (this.registration.IsEdit) {
          // add a no payment or select payment option
          const nonePaymentMethod = new EventPaymentMethod();
          nonePaymentMethod.Accept = true;
          nonePaymentMethod.Descr = this._translationService.getInstantTitlecase(
            'events.registration.wizard.payment-info.additional-payment-select-dropdown-label'
          );
          nonePaymentMethod.PaymentMethodId = 0;
          this._utilService.arrayAddEntryToBeginning(this.paymentMethods, nonePaymentMethod);
          //// set none as the default for edit

          // default
          this.registration.Registration.PaymentOptionForEdit = 0;
        }

        this.hasPaymentOptionFees = this.paymentMethods.some(function (x) {
          return x && x.Fee && x.Fee > 0;
        });

        this.updateRegistrationWithSelectedPaymentMethod();
      });

    this._eventPromoCodesService.getEventPromoCodes(this.event.EventId).then((data: Array<EventPromoCode>) => {
      this.eventPromoCodes = data;
    });

    const getRegistrationRevenuePromise = this._registrationService
      .getRegistrationRevenue(this.registrationId)
      .then((data: RegistrationRevenue) => {
        this.registration.Registration.PaymentAmount = data.AdjustedAmountPaid;
        this.registration.Registration.AlreadyPaidAmountForEdit = data.AdjustedAmountPaid;
        // looks at the existing invoice (it may have been manually editied)
        if (data.HasPostedInvoices || data.HasPostedPayments) {
          const postedSignups = data.Invoices.reduce((acc, invoice) => {
            const signupIds = invoice.InvoiceLineItems.filter(
              (li) => li.EventSignUpId > 0 && (li.Posted || li.InvoicePayments.some((p) => p.Posted))
            ).map((li) => li.EventSignUpId);
            return acc.concat(signupIds);
          }, []);
          this.actionTracker.setPostedSignupIds(postedSignups);

          const postedCustomFieldResponses = data.Invoices.reduce((acc, invoice) => {
            const signupIds = invoice.InvoiceLineItems.filter(
              (li) => li.EventCustomRegFieldResponseId > 0 && (li.Posted || li.InvoicePayments.some((p) => p.Posted))
            ).map((li) => li.EventCustomRegFieldResponseId);
            return acc.concat(signupIds);
          }, []);
          this.actionTracker.setPostedResponseIds(postedCustomFieldResponses);
        }

        this.loadedRevenue = data;
        this.registration.Registration.TotalAmount = data.AdjustedInvoicedAmount;
        // store the original amount paid before any modifications are made
        // this is used so we know if we need to display a payment adjustment type or not
        // if this is 0 we will have no adjustments needed for payments
        this.originalAmountPaid = data.AdjustedAmountPaid;
        this.registration.Registration.OriginalItemTotalAmount = data.AdjustedInvoicedAmount;
        // Load values straight from the backend. Not through frontend calculations.
        if (data.Invoices[0]) {
          this.registration.Registration.AdditionalPaymentAmountForEdit = data.Invoices[0]?.AdjustedAmountDue;
          this.MapInvoiceLineItemsToEventItemTotals(data.Invoices[0].InvoiceLineItems);
        } else {
          this.registration.Registration.AdditionalPaymentAmountForEdit = 0;
        }
        this.registration.Registration.TaxAmount = data.TaxAmount;
        this.registration.Registration.PreTaxPreDiscountAmount = data.PreTaxAndDiscountAmount;
        this.registration.Registration.DiscountTotal = data.PromoCodeAdjustmentAmount;
        this.registration.Registration.BenefitsToApplyTotal = data.PreviouslyAppliedBenefitsAmount;

        //Map InvoiceLineItems to EventItemTotals.

        this.updateRegistrationWithSelectedPaymentMethod();

        if (this.registration.IsEdit) {
          if (this.registration.Registration.DoNotInvoice == true) {
            if (this.registration.ModificationOptions.DoNotModifyInvoice == false) {
              // default this to do not modify
              this.registration.ModificationOptions.DoNotModifyInvoice = true;
            }
          } else {
            this._configService.getConfigSetting('CheckDoNotModifyInvoicesPaymentsByDefault').then((data: ConfigSetting) => {
              if (data.SettingValue?.toLowerCase() === 'true') {
                this.registration.ModificationOptions.DoNotModifyInvoice = true;
              }
            });
          }
        }

        this.initialLoadComplete = true;
      });

    const getRegistrationPromoCodesPromise = this._registrationService
      .getRegistrationPromoCodes(this.registrationId)
      .then((data: Array<any>) => {
        this.registration.PromoCodes = data;

        this.updateRegistrationWithSelectedPaymentMethod();
      });

    // 3 = Credit Card Payment Option
    if (this.registration && this.registration.Registration && this.registration.Registration.PaymentOption == 3) {
      if (isSavedCardSelected(this.selectedGatewayPaymentProfile?.CcPaymentProfileId)) {
        this.copySelectedCardOnFile();
      } else {
        this.copyContactInfoToCCContactInfo();
      }
    }

    this.checkCardConnect();

    return Promise.all([
      getEventPaymentMethodPromise,
      getRegistrationPromoCodesPromise,
      getRegistrationRevenuePromise,
      this.checkGatewaysAndCardOnFile(),
    ]).then((results) => {
      // payment methods and revenue are both loaded here: initialise the invoiced fee state once
      this.initialiseInvoicedFeesFromRevenue(this.loadedRevenue);
      return results;
    });
  }

  /**
   * Edit mode: populate ExistingPaymentOptionFees and PreviouslyInvoicedItemAmount from the saved invoice(s),
   * never from the live cart. A fee line is a non-tax line whose ItemNum matches the ItemNum of an event payment
   * method with a fee (the backend stores it under the first item's EventSignUpId, so that cannot identify it).
   * ExistingPaymentOptionFeesSet is deliberately left untouched: it drives payment method selection.
   */
  private initialiseInvoicedFeesFromRevenue(data: RegistrationRevenue): void {
    if (!this.registration.IsEdit || !data || !data.Invoices) {
      return;
    }
    // only percentage-fee edits are preset; flat-fee and no-fee edits keep the lazy-capture path
    const selected = this.registration.Registration.SelectedPaymentMethod;
    if (!selected || !(selected.Fee > 0) || selected.FeeType != 1) {
      return;
    }
    const feeMethods = (this.paymentMethods ?? []).filter((m) => m && m.Fee > 0 && m.FeeType == 1 && m.ItemNum > 0);
    const feeItemNums = feeMethods.map((m) => m.ItemNum);
    // A fee may share its revenue item with an event item, so the item line and the fee line carry the same ItemNum.
    // Where they do, the fee line is the one written with the payment method's fee description.
    const norm = (d: string): string => (d ?? '').trim().toLowerCase();
    const feeDescrs = (itemNum: number): string[] =>
      feeMethods
        .filter((m) => m.ItemNum === itemNum)
        .reduce((acc: string[], m) => acc.concat([norm(m.FeeDescr), norm(m.Descr), norm(m.PaymentMethodDescr), 'payment fee']), [])
        .filter((d) => d.length > 0);
    const nonTaxLines: InvoiceLineItemDto[] = [];
    for (const invoice of data.Invoices) {
      for (const li of invoice.InvoiceLineItems ?? []) {
        if (!(li.TaxAppliedToLineItemId > 0)) {
          nonTaxLines.push(li);
        }
      }
    }
    // only ever narrows the ItemNum match: when no line of that ItemNum carries a fee description, every one is a fee line
    const isFeeLine = (li: InvoiceLineItemDto): boolean => {
      if (!feeItemNums.includes(li.ItemNum)) {
        return false;
      }
      const descrs = feeDescrs(li.ItemNum);
      return !nonTaxLines.some((o) => o.ItemNum === li.ItemNum && descrs.includes(norm(o.Descr))) || descrs.includes(norm(li.Descr));
    };
    // adjusted amount = line Amount + line Adjustments (promo discounts are negative adjustments on a gross line);
    // same rule as the server's BuildEditFeeContextFromInvoice. The legacy revenue builder can list one adjustment
    // twice, so an adjustment carrying an id is counted once.
    const adjustedAmount = (li: InvoiceLineItemDto): number => {
      const seenAdjustmentIds = new Set<number>();
      let adjustments = 0;
      for (const a of li.Adjustments ?? []) {
        if (a.AdjustmentId > 0) {
          if (seenAdjustmentIds.has(a.AdjustmentId)) {
            continue;
          }
          seenAdjustmentIds.add(a.AdjustmentId);
        }
        adjustments += a.AdjustmentAmount ?? 0;
      }
      return li.Amount + adjustments;
    };
    let invoicedFees = 0;
    let invoicedItems = 0;
    for (const li of nonTaxLines) {
      if (isFeeLine(li)) {
        invoicedFees += adjustedAmount(li);
      } else {
        invoicedItems += adjustedAmount(li);
      }
    }
    this.registration.Registration.ExistingPaymentOptionFees = this._utilService.round(Math.max(0, invoicedFees), 2);
    this.registration.Registration.InvoicedPaymentOptionFees = this.registration.Registration.ExistingPaymentOptionFees;
    this.registration.Registration.PreviouslyInvoicedItemAmount = this._utilService.round(Math.max(0, invoicedItems), 2);
  }

  public checkCardConnect = (): void => {
    // can't mix and match card connect gateways with other gateways. if there's a card connect gateway, use it.
    this._creditCardGatewayService.hasCardConnectCreditCardGateways().then((data) => {
      if (data) this.creditCardInputComponent.useCardConnect = true;
    });
  };

  // mirrors the [hidden] condition on the credit-card-input block in the template -
  // tokenization should never be attempted when that input isn't shown to the user
  public isCreditCardInputHidden(): boolean {
    return (
      (this.registration.IsEdit && this.registration.Registration.PaymentOptionForEdit != 3) ||
      (!this.registration.IsEdit && this.registration.Registration.PaymentOption != 3) ||
      this.registration.Registration.AdditionalPaymentAmountForEdit <= 0 ||
      (this.registration.IsEdit &&
        this.registration.ModificationOptions.DoNotModifyInvoice &&
        this.registration.Registration.AdditionalPaymentAmountForEdit == 0)
    );
  }

  public async prepareForPayment(): Promise<void> {
    const usingExistingCardOnFile = isSavedCardSelected(this.selectedGatewayPaymentProfile?.CcPaymentProfileId);
    const needsNewCardTokenized = !this.isCreditCardInputHidden() && !usingExistingCardOnFile;

    if (this.creditCardInputComponent?.usePreczn && needsNewCardTokenized) {
      await this.creditCardInputComponent.prepareForSubmit();
    }
  }

  private async checkGatewaysAndCardOnFile(): Promise<void> {
    const enabled = await this._creditCardService.hasCreditCardOnFileEnabled();
    this.hasCreditCardOnFileEnabled = enabled;
    if (!enabled) return;

    const paymentTypeIds = [
      ...new Set(this.registration.Items.filter((i) => i.Quantity > 0 && i.PaymentTypeId > 0).map((i) => i.PaymentTypeId)),
    ];

    if (!paymentTypeIds.length) return;

    const data: RegistrationPaymentGatewaysDto = await this._registrationService.getGatewaysForPaymentTypes(paymentTypeIds);
    if (data.GatewayIds?.length > 1 && !data.AllGatewaysArePreczn) {
      this.hasCreditCardOnFileEnabled = false;
    } else if (data.GatewayIds?.length > 0) {
      this._primaryGatewayId = data.GatewayIds[0];
    }
  }

  public loadCardOnFileData = (profileId: number, gatewayId: number): void => {
    this._creditCardService.getGatewayCustomerProfile(profileId, gatewayId).then((data: GatewayCustomerProfile) => {
      this.gatewayCustomerProfile = data;
      this.gatewayPaymentProfiles = this.gatewayCustomerProfile.PaymentProfiles;

      var _paymentProfile = new GatewayPaymentProfile();
      _paymentProfile.CcPaymentProfileId = '';
      _paymentProfile.AccountType = 0;
      _paymentProfile.ECheckType = 0;
      this._translationService
        .getTitlecase('events.registration.wizard.payment-info.card-on-file-new-card')
        .then((translation) => (_paymentProfile.CardNumber = translation));
      this.gatewayPaymentProfiles.unshift(_paymentProfile);
    });
  };

  public onGatewayPaymentProfileChange = (data: any): void => {
    const selected = isSavedCardSelected(data)
      ? this.gatewayPaymentProfiles?.find((x) => String(x.CcPaymentProfileId) === String(data))
      : undefined;
    this.selectedGatewayPaymentProfile = selected ?? new GatewayPaymentProfile();
    this.copySelectedCardOnFile();
  };

  public getValidationResult = (): ValidationResult => {
    let valid = new ValidationResult();
    valid.isValid = true;

    let evalPaymentOptionId = this.registration.Registration.PaymentOption;
    if (this.registration.Registration.AdditionalPaymentAmountForEdit > 0) {
      if (this.registration.IsEdit) {
        //if they have chosen a new payment option for the edit so use this to do the eval
        evalPaymentOptionId = this.registration.Registration.PaymentOptionForEdit;
      }
    }

    // no validation
    if (this.registration && this.registration.ModificationOptions && this.registration.ModificationOptions.DoNotModifyInvoice)
      return valid;

    let selectedItemsNeedingPayment = this.registration.Items.filter((item: RegistrationItem) => {
      return item.Quantity > 0 && item.ExtendedPrice > 0;
    });

    //PaymentOptionAsString = CASE WHEN EventSignUps.PaymentOption = 1 THEN 'Bill Later' WHEN EventSignUps.PaymentOption = 2 THEN 'Pay At Door' WHEN EventSignUps.PaymentOption = 3 THEN 'Credit Card' WHEN EventSignUps.PaymentOption = 4 THEN 'Purchase Order'ELSE '' END
    if (this.registration.Registration.AdditionalPaymentAmountForEdit > 0) {
      if (
        selectedItemsNeedingPayment.length > 0 &&
        evalPaymentOptionId == 3 &&
        !isSavedCardSelected(this.selectedGatewayPaymentProfile?.CcPaymentProfileId)
      ) {
        //credit card payment option

        valid = this.creditCardInputComponent.getValidationResult();
      }
      if (valid.isValid == false) {
        //error set above
      } else if (evalPaymentOptionId == 1 || evalPaymentOptionId == 2) {
        //pay at door or bill later options
        valid.isValid = true;
      }
      //else if (this._utilService.isNullOrLessThanOrEqualToZero(evalPaymentOptionId)) {
      //    //purchase order payment option
      //    valid.isValid = false;
      //    valid.errors.push(this._translationService.getInstant("events.registration.wizard.payment-info.payment-option-payment-info-needed-validation-error"));

      //}
    }

    //if (this.registration.IsEdit && this.registration.EditOriginalItemsChanged && this.registration.ModificationOptions.CreateUnappliedPayments == true && this.registration.ModificationOptions.UnappliedPaymentPaymentypeId <= 0) {
    //    //
    //    valid.isValid = false;
    //    valid.errors.push(this._translationService.getInstant("events.registration.wizard.payment-info.modification-option-unapplied-payment-type-needed-validation-error"));

    //}
    if (
      this.registration.IsEdit &&
      this.registration.EditOriginalItemsChanged &&
      this.originalAmountPaid > 0 &&
      this.registration.ModificationOptions.PaymentAdjustmentTypeId <= 0
    ) {
      //
      valid.isValid = false;
      valid.errors.push(
        this._translationService.getInstant(
          'events.registration.wizard.payment-info.modification-option-payment-adjustment-type-needed-validation-error'
        )
      );
    }

    //if (this.registration.IsEdit && this.registration.EditOriginalItemsChanged && this.registration.ModificationOptions.InvoiceAdjustmentTypeId <= 0) {
    //    //
    //    valid.isValid = false;
    //    valid.errors.push(this._translationService.getInstant("events.registration.wizard.payment-info.modification-option-invoice-adjustment-type-needed-validation-error"));

    //}

    return valid;
  };

  public onPaymentOptionChange = async (data: string): Promise<void> => {
    //the option comes thru as a string convert to int
    if (this.registration.IsEdit) {
      this.registration.Registration.PaymentOptionForEdit = parseInt(data);
    } else {
      this.registration.Registration.PaymentOption = parseInt(data);
    }

    this.updateRegistrationWithSelectedPaymentMethod();
    // the invoiced fee state is derived from the saved invoice for whichever method is selected now: the method
    // saved with the registration is not necessarily the percentage-fee one the user switches to
    this.initialiseInvoicedFeesFromRevenue(this.loadedRevenue);
    this._registrationService.calculateTotals(this.registration);

    // 3 = Credit Card Payment Option
    const isCreditCard =
      (!this.registration.IsEdit && this.registration.Registration.PaymentOption == 3) ||
      (this.registration.IsEdit && this.registration.Registration.PaymentOptionForEdit == 3);

    if (isCreditCard) {
      this.copyContactInfoToCCContactInfo();
      await this.checkGatewaysAndCardOnFile();
      if (this.hasCreditCardOnFileEnabled) {
        this.loadCardOnFileData(this.registration.Registration.ProfileId, this._primaryGatewayId);
      }
    }
  };

  public updateRegistrationWithSelectedPaymentMethod = (): void => {
    // ExistingPaymentOptionFeesSet doesn't get set if there are no existing fees.
    // If the payment option gets changed (obviously after load) and payment fee has never been calculated, then act like it has.
    if (
      this.registration.Registration.ExistingPaymentOptionFeesSet == false &&
      this.registration.Registration.PaymentOptionForEdit > 0 &&
      this.registration.Registration.PaymentOption != this.registration.Registration.PaymentOptionForEdit
    )
      this.registration.Registration.ExistingPaymentOptionFeesSet = true;

    for (let payMethod of this.paymentMethods) {
      let evalMethodId = this.registration.Registration.PaymentOption;

      if (this.registration.IsEdit) {
        //evalMethodId = this.registration.Registration.PaymentOptionForEdit;
        //if (this.registration.Registration.PaymentOptionForEdit > 0) {
        //    //if they have chosen a new payment option for the edit so use this to do the eval
        //    evalMethodId = this.registration.Registration.PaymentOptionForEdit;
        //}

        if (this.registration.Registration.ExistingPaymentOptionFeesSet == true) {
          evalMethodId = this.registration.Registration.PaymentOptionForEdit;
        }
      }

      if (payMethod.PaymentMethodId == evalMethodId) {
        this.registration.Registration.SelectedPaymentMethod = payMethod;
      }
    }
  };

  public applyPromoCode(): void {
    this.showPromoCodeNotStarted = false;
    this.showPromoCodeExpired = false;
    this.showPromoCodeMaxedOut = false;

    if (
      this.selectedPromoCode &&
      !this.registration.PromoCodes.find((p) => {
        return p.PromoCodeId == this.selectedPromoCode;
      })
    ) {
      let promoCode = this.eventPromoCodes.find((p) => {
        return p.PromoCodeId == this.selectedPromoCode;
      });

      let endDate = new Date(promoCode.EndDate.getFullYear(), promoCode.EndDate.getMonth(), promoCode.EndDate.getDate(), 0, 0, 0);

      let today = new Date();
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0);

      const startDate = new Date(promoCode.StartDate.getFullYear(), promoCode.StartDate.getMonth(), promoCode.StartDate.getDate(), 0, 0, 0);

      if (promoCode.MaxUses > 0 && promoCode.Used >= promoCode.MaxUses) {
        this.showPromoCodeMaxedOut = true;
      } else if (startDate > today) {
        this.showPromoCodeNotStarted = true;
      } else if (endDate < today) {
        this.showPromoCodeExpired = true;
      } else {
        this.registration.PromoCodes.push(promoCode);
        this.actionTracker.addAction({
          KeyValue: promoCode.PromoCodeId,
          OldValue: false,
          NewValue: true,
          Type: EventRegistationActionTypeEnum.PromoCodeChanged,
        } as EventRegistrationEditActionDto);

        this.selectedPromoCode = 0;
        this.getItemTotals();
      }
    }
  }

  public hidePromoCode = (promoCodeId: number, eventItemIds: number[]): boolean => {
    return (
      this.registration.PromoCodes.some((p) => p.PromoCodeId == promoCodeId) ||
      (eventItemIds.length > 0 &&
        // hide if event items for this promo code haven't been selected
        !eventItemIds.some((e) => this.registration.Items.some((ri) => ri.EventItemId == e && ri.Quantity > 0)))
    );
  };

  public showPromoCodes = (): boolean => {
    return (
      this.eventPromoCodes.some((p) => p.EventItemIds.length == 0) ||
      this.registration.Items.some(
        (i) => i.Quantity > 0 && this.eventPromoCodes.some((pc) => pc.EventItemIds.some((eid) => eid == i.EventItemId))
      )
    );
  };

  public removePromoCode = (promoCodeId: number): void => {
    let index = this.registration.PromoCodes.findIndex((p) => p.PromoCodeId == promoCodeId);
    if (index > -1) {
      this.registration.PromoCodes.splice(index, 1);
    }
    this.actionTracker.addAction({
      KeyValue: promoCodeId,
      OldValue: true,
      NewValue: false,
      Type: EventRegistationActionTypeEnum.PromoCodeChanged,
    } as EventRegistrationEditActionDto);
    this.getItemTotals();
  };

  public getItemTotals = (): void => {
    this._registrationService.calculateTotals(this.registration);
  };

  public quantityChanged = (): void => {
    this.getItemTotals();
  };

  public onDoNotAddPaymentOptionFeeChange = (evt: any = null): void => {
    this._registrationService.calculateTotals(this.registration);
  };

  /**
   * copy address from regiration contact to cc contatct info
   */
  public copyContactInfoToCCContactInfo(): void {
    if (!this.registration.Registration.CreditCardPayment) this.registration.Registration.CreditCardPayment = new CreditCardPaymentInfo();
    if (!this.registration.Registration.CreditCardPayment.CreditCardContactInfo)
      this.registration.Registration.CreditCardPayment.CreditCardContactInfo = new CreditCardContactInfo();

    // copy fields
    let nameOnCard = this.registration.Registration.FName;

    if (this.registration.Registration.LName) {
      if (nameOnCard) nameOnCard += ' ' + this.registration.Registration.LName;
      else nameOnCard = ' ' + this.registration.Registration.LName;
    }

    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.NameOnCard = nameOnCard;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.FirstName = this.registration.Registration.FName;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.LastName = this.registration.Registration.LName;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.OrgName = this.registration.Registration.OrgName;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.Address1 = this.registration.Registration.Address1;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.Address2 = this.registration.Registration.Address2;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.City = this.registration.Registration.City;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.State = this.registration.Registration.State;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.Zip = this.registration.Registration.Zip;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.ZipExt = this.registration.Registration.ZipExt;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.Country = this.registration.Registration.Country;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.Phone = this.registration.Registration.Phone;
    this.registration.Registration.CreditCardPayment.CreditCardContactInfo.Email = this.registration.Registration.Email;
  }

  public copySelectedCardOnFile(): void {
    if (!this.registration.Registration.GatewayPaymentProfile) {
      this.registration.Registration.GatewayPaymentProfile = new GatewayPaymentProfile();
    }

    this.registration.Registration.GatewayPaymentProfile = this.selectedGatewayPaymentProfile;

    //console.error(this.registration.Registration.SelectedGatewayPaymentProfile);
    //console.error(this.selectedGatewayPaymentProfile);
  }

  public refreshBenefits = (): void => {
    this.hasBenefitsThatCanBeUsed = false;
    this.availableEventBenefits = new Array<EventBenefit>();
    this.availableProfileBenefits = new Array<ProfileBenefit>();
    this.availableBenefitsToUse = new Array<EventBenefit>();

    if (this.registration.Registration.ProfileId > 0) {
      let p1 = this._benefitService.getEventBenefits(this.event.EventId).then((data: Array<EventBenefit>) => {
        let selectedItemIds = this.registration.Items.filter((x) => x.Quantity > 0).map((x) => x.EventItemId);
        this.availableEventBenefits = data.filter((eventBenefit) => {
          // "Selected" property is not used in this case.
          return eventBenefit.EventItems.some((ebItem) => selectedItemIds.indexOf(ebItem.EventPriceId) > -1);
        });
      });

      let p2 = this._benefitService
        .getProfileEventBenefits(this.registration.Registration.ProfileId, this.event.EventId)
        .then((data: Array<ProfileBenefit>) => {
          this.availableProfileBenefits = data;
        });

      Promise.all([p1, p2]).then(() => {
        //use only benefits allowed for the vent that the profile also has and has not yet used up
        if (this.availableEventBenefits.length > 0 && this.availableProfileBenefits.length > 0) {
          this.availableBenefitsToUse = new Array<EventBenefit>();

          for (let profileBenefit of this.availableProfileBenefits) {
            if (profileBenefit.QuantityRemaining > 0 || profileBenefit.ValueRemaining > 0) {
              for (let eventBenefit of this.availableEventBenefits) {
                if (eventBenefit.BenefitTypeId == profileBenefit.BenefitTypeId) {
                  this.hasBenefitsThatCanBeUsed = true;
                  this.availableBenefitsToUse.push(eventBenefit);
                }
              }
            }
          }
        }

        //if this had previous benefits applied immediately set them to current benefits being used
        //as our ui will deal with only benefits we think we are going use going forward as old ones are cleared out on edit
        if (
          this.registration.Registration.BenefitsPreviouslyAppliedTotal > 0 &&
          this.registration.Registration.BenefitsPreviouslyApplied.length > 0
        ) {
          // original implimentation supported a single benefit at a time. keeping it that way for now.
          let previousEventBenefitId = this.registration.Registration.BenefitsPreviouslyApplied[0].EventBenefitId;
          let previousBenefitsQuantity = this.registration.Registration.BenefitsPreviouslyApplied.reduce(
            (sum, b) => sum + b.QuantityToApply,
            0
          );
          let previousBenefitsValue = this.registration.Registration.BenefitsPreviouslyApplied.reduce((sum, b) => sum + b.ValueToApply, 0);
          //for (let ben of this.registration.Registration.BenefitsPreviouslyApplied) {
          //    previousBenefitsQuantity = previousBenefitsQuantity + ben.QuantityToApply;
          //    previousBenefitsValue = previousBenefitsValue + ben.ValueToApply;
          //}

          this.registration.Registration.BenefitsToApply = this.registration.Registration.BenefitsPreviouslyApplied;
          this.registration.Registration.BenefitsToApplyTotal = this.registration.Registration.BenefitsPreviouslyAppliedTotal;

          //this.registration.Registration.BenefitsPreviouslyApplied = new Array<RegistrationProfileBenefit>();
          //this.registration.Registration.BenefitsPreviouslyAppliedTotal = 0;

          //select the benefit from the list as if a user had - comes thru as string value
          this.onBenefitChange(previousEventBenefitId.toString());

          //set the amounts/quantity after selecting the item in the dropdown
          this.selectedRegistrationBenefit.ValueToApply = previousBenefitsValue;
          this.selectedRegistrationBenefit.QuantityToApply = previousBenefitsQuantity;
        }
      });
    } else {
      this.availableEventBenefits = new Array<EventBenefit>();
      this.availableProfileBenefits = new Array<ProfileBenefit>();
    }
  };

  public onBenefitChange = (data: string) => {
    this.selectedRegistrationBenefit = new RegistrationProfileBenefit();

    let selectedEventBenefitId = parseInt(data);
    this.selectedEventBenefit.EventBenefitId = selectedEventBenefitId;

    let eventBenefitResult = this.availableBenefitsToUse.find((x: EventBenefit) => {
      return x.EventBenefitId == selectedEventBenefitId;
    });
    if (this._utilService.isNotNullOrUndefined(eventBenefitResult)) {
      this._utilService.mapSafe(eventBenefitResult, this.selectedEventBenefit);
      this.selectedEventBenefit.EventItems = [];
      for (let it of eventBenefitResult.EventItems) {
        let epb = new EventPriceBenefit();
        this._utilService.mapSafe(it, epb);
        this.selectedEventBenefit.EventItems.push(epb);
      }

      let profileBenefitResult = this.availableProfileBenefits.find((x: ProfileBenefit) => {
        return x.BenefitTypeId == eventBenefitResult.BenefitTypeId;
      });
      if (this._utilService.isNotNullOrUndefined(profileBenefitResult)) {
        this._utilService.mapSafe(profileBenefitResult, this.selectedProfileBenefit);

        this.selectedRegistrationBenefit = new RegistrationProfileBenefit();
        this.selectedRegistrationBenefit.BenefitType = this.selectedEventBenefit.BenefitType;
        this.selectedRegistrationBenefit.BenefitTypeId = this.selectedProfileBenefit.BenefitTypeId;
        this.selectedRegistrationBenefit.EventBenefitId = this.selectedEventBenefit.EventBenefitId;
        this.selectedRegistrationBenefit.ProfileBenefitId = this.selectedProfileBenefit.Id;
        this.selectedRegistrationBenefit.ProfileId = this.selectedProfileBenefit.ProfileId;

        this.selectedRegistrationBenefit.LimitType = this.selectedEventBenefit.LimitType;
        this.selectedRegistrationBenefit.LimitAmount = this.selectedEventBenefit.LimitAmount;
        this.updateBenefitSuggestedAmountToUse();
        //this.applyBenefit();
      }
    }
  };
  public updateBenefitSuggestedAmountToUse = (): void => {
    let maxAllowed = this.getMaxBenefitAmountAllowed();

    this.selectedRegistrationBenefit.ValueToApply = maxAllowed;
  };

  public getMaxAmtOfBenefitsThatCanBeUsedForItems = (): number => {
    //per lauren base on items totals not payment option fees and taxes
    let max = 0;
    for (let itemTotal of this.registration.Registration.EventItemTotals) {
      max = max + itemTotal.Total;
    }
    return max;
  };

  public getMaxBenefitAmountAllowed = (): number => {
    let max = this.getMaxAmtOfBenefitsThatCanBeUsedForItems();

    if (this.selectedProfileBenefit.ValueRemaining < max) {
      max = this.selectedProfileBenefit.ValueRemaining;
    }
    return max;
  };
  public getMaxBenefitQuantityAllowed = (): number => {
    let max = this.getMaxAmtOfBenefitsThatCanBeUsedForItems();

    if (this.selectedProfileBenefit.QuantityRemaining < max) {
      max = this.selectedProfileBenefit.QuantityRemaining;
    }
    return max;
  };

  public applyBenefit(): void {
    let previousBenefitsValue = this.registration.Registration.BenefitsPreviouslyApplied.reduce((sum, b) => sum + b.ValueToApply, 0);
    this.registration.Registration.BenefitsToApply = new Array<RegistrationProfileBenefit>();
    if (this.selectedRegistrationBenefit.BenefitTypeId > 0) {
      let maxAllowed: number = 0;
      let maxAmount: number = 0;
      // the totals amount of all items. if this amount is somehow exceeded, we fix it.
      let itemsTotal = this.getMaxAmtOfBenefitsThatCanBeUsedForItems();
      let remainingQuantityToApply: number;
      let remainingAmountToApply: number;
      if (this.selectedEventBenefit.LimitType == 1) {
        maxAllowed = this.selectedProfileBenefit.QuantityRemaining;
        remainingQuantityToApply = this.selectedRegistrationBenefit.QuantityToApply;
        if (remainingQuantityToApply > maxAllowed) remainingQuantityToApply = maxAllowed;
      } else {
        maxAmount = this.getMaxBenefitAmountAllowed();
        remainingAmountToApply = this.selectedRegistrationBenefit.ValueToApply;
        if (remainingAmountToApply > maxAmount) remainingAmountToApply = maxAmount;
      }
      let totalApplied: number = 0;
      for (let selectedItem of this.registration.Items) {
        if (selectedItem.Quantity > 0 && (remainingQuantityToApply > 0 || remainingAmountToApply > 0) && totalApplied < itemsTotal) {
          let macthingEventBenefit = this.selectedEventBenefit.EventItems.find((x) => x.EventPriceId == selectedItem.EventItemId);
          if (this._utilService.isNotNullOrUndefined(macthingEventBenefit)) {
            let benefitPerItemAmt = this._utilService.round(selectedItem.ExtendedPrice / selectedItem.Quantity, 2);
            let newRegistrationBenefit: RegistrationProfileBenefit = new RegistrationProfileBenefit();
            this._utilService.mapSafe(this.selectedRegistrationBenefit, newRegistrationBenefit);
            newRegistrationBenefit.EventPriceId = selectedItem.EventItemId;
            if (newRegistrationBenefit.LimitType == 1) {
              newRegistrationBenefit.QuantityToApply = Math.min(selectedItem.Quantity, remainingQuantityToApply);
              newRegistrationBenefit.ValueToApply = benefitPerItemAmt * newRegistrationBenefit.QuantityToApply;
              remainingQuantityToApply -= newRegistrationBenefit.QuantityToApply;
            } else {
              newRegistrationBenefit.QuantityToApply = 0;
              newRegistrationBenefit.ValueToApply = Math.min(benefitPerItemAmt * selectedItem.Quantity, remainingAmountToApply);
              remainingAmountToApply -= newRegistrationBenefit.ValueToApply;
            }
            totalApplied += newRegistrationBenefit.ValueToApply;

            // if the total benefits somehow exceed the items total, we fix it here.
            if (totalApplied > itemsTotal) {
              newRegistrationBenefit.ValueToApply = Math.max(0, newRegistrationBenefit.ValueToApply - (itemsTotal - totalApplied));
            }

            this.registration.Registration.BenefitsToApply.push(newRegistrationBenefit);
          }
        }
      }

      this.actionTracker.addAction({
        OldValue: previousBenefitsValue,
        NewValue: this.selectedRegistrationBenefit.ValueToApply,
        Type: EventRegistationActionTypeEnum.BenefitChanged,
        KeyValue: this.selectedRegistrationBenefit.ProfileBenefitId,
      } as EventRegistrationEditActionDto);
    }
    //if (this.selectedRegistrationBenefit.BenefitTypeId > 0) {
    //    // clear the benefits applied to since we're recalculating everything anyway
    //    this.selectedRegistrationBenefit.EventItemsAppliedTo = new Array<RegistrationEventItemBenefit>();
    //    //ensure is less that allowed
    //    let maxAllowed = 0;
    //    if (this.selectedEventBenefit.LimitType == 1) {
    //        maxAllowed = this.getMaxBenefitQuantityAllowed();
    //        this.selectedRegistrationBenefit.ValueToApply = 0;
    //        if (this.selectedRegistrationBenefit.QuantityToApply > maxAllowed) {
    //            this.selectedRegistrationBenefit.QuantityToApply = maxAllowed
    //        }
    //        //this is quantity so back into what the $ value is
    //        let benefitPerItemAmt = 0;
    //        let totalToApply = 0;
    //        let remainingQuantityToApply = this.selectedRegistrationBenefit.QuantityToApply;
    //        for (let selectedItem of this.registration.Items) {
    //            if (selectedItem.Quantity > 0 && remainingQuantityToApply > 0) {
    //                let macthingEventBenefit = this.selectedEventBenefit.EventItems.find(x => x.EventPriceId == selectedItem.EventItemId);
    //                if (this._utilService.isNotNullOrUndefined(macthingEventBenefit)) {
    //                    benefitPerItemAmt = this._utilService.round(selectedItem.ExtendedPrice / selectedItem.Quantity, 2);
    //                    let eventItemBenefit = new RegistrationEventItemBenefit();
    //                    eventItemBenefit.EventItemId = selectedItem.EventItemId;
    //                    eventItemBenefit.QuantityApplied = Math.min(selectedItem.Quantity, remainingQuantityToApply)
    //                    eventItemBenefit.ValueApplied = benefitPerItemAmt * eventItemBenefit.QuantityApplied;
    //                    remainingQuantityToApply -= eventItemBenefit.QuantityApplied;
    //                    totalToApply += eventItemBenefit.ValueApplied;
    //                    this.selectedRegistrationBenefit.EventItemsAppliedTo.push(eventItemBenefit);
    //                }

    //            }
    //        }
    //        this.selectedRegistrationBenefit.ValueToApply = totalToApply;
    //        let max = this.getMaxAmtOfBenefitsThatCanBeUsedForItems();
    //        if (max < this.selectedRegistrationBenefit.ValueToApply) {
    //            this.selectedRegistrationBenefit.ValueToApply = max;
    //        }

    //    } else {
    //        maxAllowed = this.getMaxBenefitAmountAllowed();
    //        this.selectedRegistrationBenefit.QuantityToApply = 0;
    //        if (this.selectedRegistrationBenefit.ValueToApply > maxAllowed) {
    //            this.selectedRegistrationBenefit.ValueToApply = maxAllowed
    //        }
    //    }

    //    this.registration.Registration.BenefitsToApply.push(this.selectedRegistrationBenefit);
    //}

    this._registrationService.calculateTotals(this.registration);
  }

  public onBenefitAmountToApplyChange = (): void => {
    //this.applyBenefit();
  };

  public onBenefitQuantityToApplyChange = (value: string): void => {
    let numValue = parseInt(value.toString());
    value = numValue.toString();
    this.selectedRegistrationBenefit.QuantityToApply = numValue;
    //this.applyBenefit();
  };

  public removeBenefits() {
    let previousBenefitsValue = this.registration.Registration.BenefitsPreviouslyApplied.reduce((sum, b) => sum + b.ValueToApply, 0);
    this.actionTracker.addAction({
      OldValue: previousBenefitsValue,
      NewValue: 0,
      Type: EventRegistationActionTypeEnum.BenefitChanged,
      KeyValue: this.selectedRegistrationBenefit.ProfileBenefitId,
    } as EventRegistrationEditActionDto);
    this.registration.Registration.BenefitsToApply = new Array<RegistrationProfileBenefit>();
  }

  doNotInvoiceChanged() {
    this.actionTracker.addAction({
      OldValue: false,
      NewValue: this.registration.Registration.DoNotInvoice,
      Type: EventRegistationActionTypeEnum.DoNotInvoiceSet,
    } as EventRegistrationEditActionDto);
  }

  private MapInvoiceLineItemsToEventItemTotals(lineItems: Array<InvoiceLineItemDto>) {
    let eventItemTotals: Array<EventItemTotal> = [];
    lineItems = lineItems.filter((x) => x.TaxAppliedToLineItemId == 0);
    for (let lineItem of lineItems) {
      let eventItemTotal: EventItemTotal = new EventItemTotal();
      eventItemTotal.EventItem = this._utilService.clone(
        this.registration.Items.find((x) => x.EventItemSignUpId == lineItem.EventSignUpId)
      );
      eventItemTotal.EventItem.Quantity = lineItem.Quantity;
      eventItemTotal.EventItem.MemberPrice = lineItem.UnitPrice;
      eventItemTotal.EventItem.NonMemberPrice = lineItem.UnitPrice;
      eventItemTotal.EventItem.DisplayPrice = lineItem.Amount;
      eventItemTotal.ItemTotal = lineItem.Amount;

      eventItemTotals.push(eventItemTotal);
      this.registration.Registration.EventItemTotals = eventItemTotals;
    }
  }
}
